module.exports = __webpack_public_path__ + "img/Public.2e8882a6.jpg";